import { Observable } from 'rxjs/Observable';
import { CatalogueService } from './../../../core/service/core/cataloque.service';
import { EqualValidator } from './../../../core/component/core/validatos/equal.validator';
import { PostalcodeValidator } from './../../../core/component/core/validatos/postalcode.validator';
import { IMyDpOptions } from 'mydatepicker';
import { Component, OnInit, Output, Input } from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  AbstractControl
} from '@angular/forms';
import { Store } from '@ngrx/store';


import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { AppState } from '../../../store/app-state';
import { CONFIG } from '../../../config';
import { CompleterService, CompleterData } from 'ng2-completer';
import { AllValidatosService } from '../../../core/component/core/validatos/all.validatos';
import { ValidatorService } from '../../../core/service/app/validator.service';
import { interval } from 'rxjs/observable/interval';
import { CommerceService } from "app/core/service/app/commerce.service";
import { ApiService } from '../../../core/service/core/api.service';
import swal from 'sweetalert2';
import { formControlBinding } from '@angular/forms/src/directives/ng_model';
import { IfObservable } from 'rxjs/observable/IfObservable';


@Component({
  selector: 'app-register-commerce-form',
  templateUrl: './register-commerce-form.component.html',
  styleUrls: ['./register-commerce-form.component.scss']
})
export class RegisterCommerceFormComponent extends FormBaseComponent<any>
  implements OnInit {

  @Input() code: string = "";

  comercios = [];
  operaciones = [];
  tipoPersonas = [];

  noContractList$;
  commerceTypeList$;
  operationYearList$;
  legalStructureList$;
  protected dataService: any;
  searchStr = '';
  municipio = '';
  postalCode = '';
  state = '';
  commerceType = '0';
  legalStructure = '0';

  constructor(
    private store: Store<AppState>,
    private completerService: CompleterService,
    private catalogo: CatalogueService,
    private validators: AllValidatosService,
    private validatorService: ValidatorService,
    private service: CommerceService,
    private apiService: ApiService
  ) {
    

    super();
    this.noContractList$ = this.store.select(state => state.list.no_contract);
    this.commerceTypeList$ = this.store.select(
      state => state.list.commerce_type
    );
    this.operationYearList$ = this.store.select(
      state => state.list.operation_year
    );
    this.legalStructureList$ = this.store.select(
      state => state.list.legal_strucutre
    );

    this.dataService = completerService.remote(
      CONFIG.url + 'catalogue/postalcode/',
      null,
      null
    );
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.init();
    this.catalogo.getTipoComercio().then(result => {
      this.comercios = result;
    });

    this.catalogo.getOperacion().then(result => {
      this.operaciones = result;
    });

    this.catalogo.getTipoPersona().then(result => {
      this.tipoPersonas = result;
    });
    

  }

  template() {
    if(this.code=="CANIR500"){
      this.legalStructure = '2';
      this.commerceType = '5';

    }

    this.form.addControl(
      'commerceName',
      new FormControl('', [Validators.required])
    );

    this.form.addControl(
      'commerceType',
      new FormControl(this.commerceType, [Validators.pattern('[0-9]{0,2}')])
    );

    this.form.addControl(
      'commerceSubType',
      new FormControl(' ', [Validators.required])
    );

    this.form.addControl(
      'operationYear',
      new FormControl(0, [Validators.pattern('[1-9]{0,2}')])
    );

    this.form.addControl(
      'legalStructure',
      new FormControl(this.legalStructure, [Validators.pattern('[1-9]{0,2}')])
    );

    this.form.addControl(
      'postalCode',
      new FormControl(
        ''//,
        //[Validators.required]
      )
    );

    this.form.addControl(
      'state',
      new FormControl(null, [Validators.required])
    );

    this.form.addControl(
      'code',
      new FormControl(this.code, [Validators.required], this.validatorService.CodigoPromotor.bind(this) )
    );
    this.form.addControl('monthlySales', new FormControl());
    this.form.addControl('monthlySalesCard', new FormControl());
    this.form.addControl('creditCard', new FormControl());
    this.form.addControl('creditCard', new FormControl());

  }

  postalCodeAsync(control: FormControl) {
    return this.validatorService
      .postalCodeSub(control.value)
      .debounceTime(2000)
      .distinctUntilChanged()
      .do(data => {
        if (data && data != this.municipio) {
          this.municipio = data.object || '';
        } else {
          this.municipio = '';
        }
        return null;
      })
      .catch(error => {
        this.municipio = '';
        return Observable.of({ error: 'Codigo Postal Invalido.' });
      });
  }

  changTipoPersona() {
    let value = this.form.get('isMoral').value;
    this.form.patchValue({ legalStructure: value ? 2 : 0 });
  }

  go() {
    if (this.form.valid) {
      window.scrollTo(0, 0);
      this.onComplete.emit(this.form.value);
      this.service.setTitulo(this.form.value.commerceName);
    }
  }

  getColonia(){
    this.postalCode = this.form.controls['postalCode'].value;
    
    if(this.postalCode != null && this.postalCode != "")
    {
      this.postalCode = this.apiService.fillPostalCode(this.postalCode);
      
      if(this.postalCode.toString().length == 5 && this.postalCode != "00000")
      {
        this.apiService.sendSub('validator/postalcode', {
          postalCode: this.postalCode
        }).subscribe(data =>
        {
          if(data.object != undefined && data.object != "")
          {
            if(data.object != "not_in_zone")
            {
              this.form.controls['state'].setValue(data.object);
              this.state = data.object;
            }
            else
            {
              this.form.controls['state'].setValue("");
              this.state = "";
              swal({
                type: 'error',
                title: 'Disculpe las molestias',
                text: 'Por el momento no contamos con la cobertura en tu Zona, si quieres tener mayor información favor de comunicarse a nuestros numeros de contacto',
              });
            }
          }          
        }, error => 
        {
          swal({
            type: 'error',
            title: 'Disculpe las molestias',
            text: 'El codigo postal proporcionado no se encuentra, favor de verificar',
          })

          this.form.controls['state'].setValue("");
          this.state = "";
        });
      }
      else{
        swal({
          type: 'error',
          title: 'Disculpe las molestias',
          text: 'El codigo postal no cumple con el formato adecuado, favor de validar',
        })
      }
    }
  }

  setsubType(){
    this.commerceType = this.form.controls['commerceType'].value;
    if(this.commerceType == "11")
    {
      this.form.controls['commerceSubType'].setValue("");
    }
    else
    {
      this.form.controls['commerceSubType'].setValue(" ");
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/register-commerce-form/register-commerce-form.component.ts